import { render } from "./PageIntro.vue?vue&type=template&id=58488699&scoped=true"
import script from "./PageIntro.vue?vue&type=script&lang=js"
export * from "./PageIntro.vue?vue&type=script&lang=js"

import "./PageIntro.vue?vue&type=style&index=0&id=58488699&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58488699"]])

export default __exports__